import {ENCOURS_START, ENCOURS_END } from '../types/blockdate';

const initialState = {
  encourstartdate: [],
  encourenddate: [],
};




/* store generation encourenddate,encourstartdate  with type ENCOURS_START, ENCOURS_END


  encourstartdate: [],
  encourenddate: [],
  
    case ENCOURS_START:
      return { ...state, encourstartdate: action.payload };

      case ENCOURS_END:
  
  */

export default (state = initialState,action) => {
  switch (action.type) {

    case ENCOURS_START:
      return { ...state, encourstartdate: action.payload };

      case ENCOURS_END:
        return { ...state, encourenddate: action.payload };

    default:
      return state;
  }
};
